import { Typography } from '@mui/material';
const Home = () => {
    return (
        <Typography fontWeight={700} variant="h4" marginLeft={'1rem'}>
            Home
        </Typography>
    );
};
export default Home;
